let NODE_ENV = window.XINPOC_DISPATCH_CONFIG.isProject;
let title = {
  towway: "two way direct",
  HPYJ: "HPYJ 调度平台",
  yuantong: "调度台",
  chunsheng: "调度台",
  TALK2ME: "Web调度程序平台",
  wanlian: "CAC调度台",
  EuroNews:"WOUXUN Global",
  ShangHaotong: "SHT POC",
  quansheng:"QUESUM",
};
let voice_title = {
  XiamenGuanhe:"Layanan khusus platform interkom membuat interkom lebih efisien.",
  wanlian: "Keselamatan Anda adalah perhatian kami.",
}
let conpanyname = {
  chunsheng:"Copyright © 2025 Poclink Radios. All Rights Reserved.",
  XiamenGuanhe:"观合通信科技（厦门）有限公司",
  TALK2ME: "Talk2Me Social Inc. (832)880-0000",
  wanlian: "CONGO ASTRAL COMPANY",
  EuroNews: "WOUXUN COMMUNICATIONS LIMITED",
}

let versions = {
  EuroNews:'V1.00.00',
  ShangHaotong: "V1.00.00",
}

module.exports = {
  language: {
    name: "Cina",
    title: "bahasa",
  },

  about: {
    title: title[NODE_ENV],
    conpanyname: conpanyname[NODE_ENV],
    version:versions[NODE_ENV] || "v1.6.2"
  },
  login: {
    account: "Masukkan akun login Anda",
    password: "Masukkan kata sandi",
    installationServices: " Instal layanan suara",
    rememberme: "ingat aku",
    Login: "Masuk",
  },
  message: {
    loginAccountTips: "Akun login tidak boleh kosong.",
    loginPasswordTips: "Kata sandi tidak boleh kosong",
    usernamePasswordTips: "Nama pengguna atau kata sandi salah",
    loginsuccessful: "Login berhasil.",
    accountNumbers: "Nomor rekening diperbolehkan!",
    noDispatcher: "Login gagal. Akun ini bukan milik seorang petugas pengiriman!",
    accountNotpresent: "Akun tidak ada!",
    LoginAbnormal: "Terjadi kesalahan saat login, silakan coba lagi!",
    voiceServiceNotInstalled: "Silakan instal layanan suara. Jika sudah, silakan segarkan peramban Anda!",
    Videocallinprogress: "Panggilan video sedang berlangsung!",
    Voicecallinprogress: "Dalam panggilan suara!",
    Youhavebeenclosedforspeaking: "Masa komentar Anda telah berakhir!",
    tctemporarygroup: "Apakah Anda ingin mengkonfirmasi pembaruan dan keluar dari grup sementara?",
    Doyouwanttologout: "Keluar?",
    prompt: "petunjuk",
    Nonetworklink: "Tidak ada koneksi jaringan.",
    deletedGro: "Grup ini telah dihapus dan tidak dapat diakses!",
    Pleaseselectthedesired: "Silakan pilih yang Anda butuhkan.",
    deletedGroUsers: "Pengguna!",
    Voicecallfunction: "Harap aktifkan fungsi panggilan suara di platform manajemen terlebih dahulu!",
    Alreadytemporary: "Panggilan telepon tidak lagi dimungkinkan di grup sementara!",
    Onlysupports: "Panggilan suara hanya dapat dilakukan ke satu pengguna!",
    Enablevoicecalls: "Pengguna ini belum mengaktifkan fungsi panggilan suara di platform manajemen!",
    Oncall: "Tidak dapat membuat konten saat sedang dalam panggilan telepon yang sibuk!",
    Shaketodeath: "Tidak dapat dibuat selama proses shake-to-die.",
    Shaketodeath2: "Grup tidak dapat diubah selama proses pengocokan untuk mematikan.",
    createregiongroups: "Anda hanya dapat membuat maksimal 3 grup regional!",
    temporarygroupsnoadd: "Membuat grup sementara sudah tidak mungkin lagi!",
    haleDispatcherGroupUser: "Hanya anggota grup operator yang dapat ditambahkan secara paksa.",
    TemporaryGroupNoHale: "Kelompok sementara tidak boleh dibentuk secara paksa!",
    Groupcallfailure: "Panggilan grup gagal",
    Exitsuccessfully: "Keluar berhasil!",
    Usernotonline: "Pengguna sedang offline!",
    Theotherpartyisbusy: "Pihak lain sedang sibuk!",
    Callfailed: "Panggilan gagal!",
    Theotherpartyhashungup: "Pihak lain sudah menutup telepon!",
    Networkconnectionfailed: "Koneksi jaringan gagal. Silakan coba lagi nanti.",
    Callended: "Panggilan berakhir!",
    Accountpassworderror: "Kata sandi akun salah",
    Arrears: "Pembayaran jatuh tempo",
    Accountdoesnotexist: "Akun tidak ada",
    Permissionerror: "Kesalahan izin",
    AccountInfoChange: "Informasi akun telah diubah.",
    Configuration: "Kesalahan informasi konfigurasi",
    accountOtherlogins: "Akun tersebut telah diakses di platform lain!",
    Accountlogintimeout: "Login akun habis waktu.",
    Networkconnectionfailure: "Koneksi jaringan gagal",
    Thenetworkisreconnecting: "Jaringan sedang terhubung kembali.",
    Addinggroupfailed: "Gagal bergabung dengan grup",
    Addgrouprequesttimeout: "Permintaan untuk bergabung dengan grup tersebut habis waktu.",
    Singlecallfailure: "Panggilan tunggal gagal",
    Failedtojointhegroup: "Gagal bergabung ke grup [Kesalahan izin]",
    Failedtojointhegroup2: "Gagal bergabung dengan grup [Tidak ada]",
    Failedtojointhegroup3: "Gagal bergabung dengan grup [Kedaluwarsa]",
    Failedtojointhegroup4: "Gagal bergabung dengan grup [Batas Kuota]",
    Failedtojointhegroup5: "Gagal bergabung dengan grup [Objek yang valid kosong]",
    noSnatchingwheat: "Mengambil beberapa mikrofon secara bersamaan dalam waktu singkat tidak diperbolehkan.",
    noRemoteclosureSnatchingwheat: "Perebutan mikrofon tidak diperbolehkan dalam kondisi tertutup jarak jauh.",
    Failedtograbthewheat: "Gagal meminta fokus audio saat mencoba meraih mikrofon.",
    Grabbingwheattimeout: "Terima batas waktu respons pengambilan mikrofon.",
    Failedtoopenrecordingdevice: "Gagal membuka perangkat perekam.",
    Accountlocked: "Akun terkunci",
    Terminallocked: "Terminal terkunci",
    Machinecardlocked: "Kartu SIM terkunci",
    Noaccountinformationconfigured: "Tidak ada informasi akun yang dikonfigurasi.",
    Successfullysaved: "Berhasil disimpan!",
    Successfullysethost: "Host berhasil diatur!",
    Successfullydeleted: "Penghapusan berhasil!",
    Successfullyadded: "Berhasil ditambahkan!",
    Successfullyremoved: "Penghapusan berhasil!",
    update_successfully: "Pembaruan berhasil",
    Successfullymodified: "Modifikasi berhasil!",
    oldpassworderror: "Kata sandi lama salah.",
    Parametererror: "Kesalahan parameter",
    Pleaseselecttheuseryouwanttoadd: "Silakan pilih pengguna yang ingin Anda tambahkan!",
    Addingfailed: "Penambahan gagal karena daftar pengguna untuk grup tersebut kosong!",
    Pleaseselectuserremoved: "Silakan pilih pengguna yang ingin Anda hapus!",
    Removalfailed: "Penghapusan gagal karena daftar pengguna grup kosong!",
    Prioritysetsuccessfully: "Penetapan prioritas berhasil",
    Pleaseselectastartandendtime: "Silakan pilih waktu mulai dan waktu berakhir.",
    endTimeNoStarttime: "Waktu berakhir tidak boleh lebih awal dari waktu mulai.",
    Thestartandendtimesmustbeonthesameday: "Waktu mulai dan waktu berakhir harus pada hari yang sama.",
    RedefineCustomization: "Jika Anda memiliki kurang dari 3 titik area kustom, harap gambar ulang!",
    Unabletocreatetemporarygroup: "Saat ini tidak ada anggota yang online, jadi grup sementara tidak dapat dibuat!",
    Pleaseenteroldpassword: "Silakan masukkan kata sandi lama Anda.",
    Pleaseenteranewpassword: "Silakan masukkan kata sandi baru Anda.",
    Confirmnewpassword: "Konfirmasi kata sandi baru",
    noSamePassword: "Kata sandi lama dan kata sandi baru tidak boleh sama!",
    noSamePasswordTow: "Kedua kata sandi tersebut tidak cocok!",
    pleaseenterpasswordagain: "Silakan masukkan kata sandi Anda lagi.",
    Successfullyprocessed: "Pemrosesan berhasil",
    voice_title: voice_title[NODE_ENV] || ""
  },
  search: "mencari",
  users: "pengguna",
  refund: "kembali",
  Loadingdesperately: "Sedang memuat dengan tergesa-gesa",
  Speaking: "Berbicara...",
  Iamspeaking: "Saya sedang berbicara...",
  communicatebytelephone: "panggilan",
  call: "panggilan",
  hale: "tarikan kuat",
  Forceddemolition: "pembongkaran paksa",
  confirm: "Tentu",
  cancel: "Membatalkan",
  dispatchIntercom: "Interkom pengiriman",
  allGroups: "Semua Grup",
  fixedGroup: "Grup Tetap",
  regionalGroup: "Kelompok Regional",
  filter: "menyaring",
  all: "semua",
  online: "On line",
  offline: "Offline",
  groupUser: "Grup/Pengguna",
  enter: "Masuk",
  edit: "sunting",
  voiceIntercom: "Interkom suara",
  baseStationSwitch: "Saklar stasiun pangkalan",
  gpsSwitch: "sakelar GPS",
  viewHistoricalTrack: "Lihat riwayat aktivitas",
  startingtime1: "Waktu mulai",
  selectionPeriod: "Pilih waktu",
  startingTime: "Waktu mulai",
  Pleaseselectadateandtime: "Silakan pilih waktu mulai.",
  EndTime: "Waktu berakhir",
  Pleaseselectanendtime: "Silakan pilih waktu berakhir",
  selectDate: "Pilih tanggal",
  SelectStartTime: "Pilih waktu mulai",
  Now: "Sekarang",
  Sure: "Tentu",
  Closure: "penutup",
  editArea: "Ubah area",
  deleteArea: "Area yang dihapus",
  Areyousuretosavethefence: "Apakah Anda yakin menyimpan pagar itu?",
  deleteLocalgroup: "Apakah Anda yakin menghapus grup area tersebut?",
  pleaseselectaregion: "Silakan pilih area yang berpagar terlebih dahulu!",
  doubleclicktocreate: "Klik dua kali untuk membuat",
  doubleclick: "klik dua kali",
  Createregionalgroups: "Buat grup wilayah",
  groupName: "Nama Grup",
  Pleaseenterthegroupname: "Silakan masukkan nama grup.",
  pleaseenteragroupname: "Silakan masukkan nama grup (terdiri dari 2-15 karakter dalam mandarin atau Indonesia).",
  groupnameTips: "Nama grup terdiri dari 2-15 karakter yang berupa angka dan abjad.",
  pleaseenteragroupnameTips: "Terdiri dari 2-15 digit dalam bahasa Mandarin atau Indonesia.",
  selectGroup: "Pilih Grup",
  Pinnedingroupusers: "Pengguna grup tetap",
  TemporaryGroup: "Pengguna grup sementara",
  Usernotingroup: "Pengguna diluar grup",
  userImei: "Pengguna/IMEI",
  Pleaseselectauser: "Silakan pilih pengguna",
  Create: "membuat",
  Cancel: "Membatalkan",
  groupEdit: "Penyuntingan kelompok",
  usersingroup: "Dalam grup pengguna",
  UsernameImei: "Nama pengguna/IMEI",
  userName: "Nama belakang",
  noData: "Tidak ada data yang tersedia.",
  removeselectedusers: "Hapus pengguna yang dipilih",
  Removeall: "Hapus semua",
  Addtheselecteduser: "Tambahkan pengguna terpilih",
  Addall: "Tambahkan semua",
  Save: "menyimpan",
  selectUser: "Pilih Pengguna",
  Edittakeseffect: "Perubahan berlaku segera.",
  UserManagement: "Manajemen Pengguna",
  Userpriority: "Prioritas Pengguna",
  levelone: "Level 1",
  Secondary: "Level 2",
  Levelthree: "Level 3",
  Levelfour: "Level 4",
  Fifthgrade: "Level 5",
  Editstakeeffectimmediately: "Perubahan berlaku segera.",
  Setmoderator: "Siapkan host",
  SelectHost: "Pilih tuan rumah",
  Host: "tuan rumah",
  Pleasechoose: "Silakan pilih",
  Deletemoderator: "Hapus host",
  Setuphost: "Hanya satu pengguna yang dapat diatur sebagai host.",
  Pleaseselectacall: "Silakan pilih konten yang ingin Anda hubungi.",
  Waitingforanswering: "Menunggu pihak lain menjawab panggilan suara.",
  Inviteyoutovoicecall: "Mengundang Anda untuk melakukan panggilan suara",
  callingusers: "Silakan pilih pengguna yang ingin Anda hubungi.",
  Forcedpullusers: "Silakan pilih pengguna yang ingin Anda paksa untuk dihapus.",
  Forceddismantlingusers: "Silakan pilih pengguna yang perlu dihancurkan secara paksa.",
  SearchLocation: "Cari lokasi",
  Show: "menunjukkan",
  Hide: "bersembunyi",
  Default: "bawaan",
  Satellite: "satelit",
  Roadconditions: "Kondisi jalan",
  Toolbox: "Kotak Peralatan",
  Ranging: "Pengukuran jarak",
  Mark: "tanda",
  Broadcast: "siaran",
  EnableBroadcastGroup: "Mohon aktifkan terlebih dahulu akses grup untuk menerima siaran.",
  textBroadcast: "Siaran teks",
  Hasbeensent: "Terkirim",
  textBroadcastContent: "Silakan masukkan pesan siaran teks Anda (tidak lebih dari 50 karakter).",
  pleaseentertextbroadcast: "Silakan masukkan siaran teks.",
  Send: "mengirim",
  voiceBroadcast: "Siaran suara",
  Clicktorecordvoicebroadcast: "Klik untuk merekam siaran audio",
  Pleaserecordthevoicebroadcast: "Silakan rekam siaran suara.",
  RecordingTime: "Waktu perekaman tidak boleh kurang dari 1 detik.",
  Broadcaster: "Penyiar radio",
  BroadcastTime: "Waktu siaran",
  listento: "Mendengarkan",
  Warningmessage: "Informasi alarm",
  AlarmHistory: "Untuk pesan peringatan lainnya, silakan periksa riwayat.",
  Name: "nama",
  Address: "alamat",
  Time: "waktu",
  Check: "Memeriksa",
  State: "negara",
  Unprocessed: "Belum diproses",
  DealWith: "menghadapi",
  delete: "menghapus",
  PTTbuttondisplay: "Tampilan tombol PTT",
  SOSalarmsound: "Suara alarm SOS",
  Fencealarmsound: "Suara alarm pagar",
  Motiontrajectorybinding: "Pelacakan pergerakan",
  Changepassword: "Ubah kata sandi",
  Logoutoflogin: "Keluar",
  Dataanalysis: "Analisis Data",
  Statisticstoday: "Statistik hari ini",
  Currentonlineusers: "Jumlah pengguna online saat ini",
  Totalnumberofusers: "Jumlah total pengguna",
  Fencerecord: "Catatan Pagar",
  SOSrecord: "Log SOS",
  recordingrecord: "Rekaman audio",
  Grouponlineusers: "Pengguna grup online",
  Comparison: "Perbandingan pengguna online selama 7 hari",
  warningcomparison: "Perbandingan peringatan 30 hari",
  Fencewarning: "Peringatan pagar",
  SOSwarning: "Peringatan SOS",
  OldPassword: "Kata Sandi Lama",
  NewPassword: "Kata Sandi Baru",
  ConfirmPassword: "Konfirmasi Kata Sandi",
  consists: "Terdiri dari 6-16 karakter alfanumerik",
  startingpoint: "titik awal",
  totallength: "Umum",
  ico: "ikon",
  date: "tanggal",
  Targeting: "Metode penentuan posisi",
  Basestationpositioning: "Penentuan posisi stasiun pangkalan",
  BeidouGPS: "BeiDou/GPS",
  direction: "arah",
  altitude: "ketinggian",
  Speed: "Kecepatan (km/jam)",
  warmreminder: "Sebagai pengingat: Data referensi berasal dari pihak ketiga dan mungkin mengandung kesalahan;",
  Iconselection: "Pemilihan ikon",
  pleaseentername: "Silakan masukkan nama",
  changeicon: "Ubah ikon",
  Universal: "Umum",
  policesecurity: "keamanan polisi",
  Firefighting: "perlindungan kebakaran",
  Chemicalindustry: "Industri Kimia",
  other: "lainnya",
  save: "menyimpan",
  close: "penutup",
  viewtag: "Lihat tag",
  addtag: "Tambahkan penanda",
  Supportsaddingamaximum: "Maksimal 10 ikon dapat ditambahkan.",
  Imageformaterror: "Kesalahan format gambar",
  uploadedimage: "Ukuran gambar yang diunggah tidak boleh melebihi 5kb!",
  uploadsuccessful: "Unggahan berhasil",
  uploadfailed: "Unggahan gagal",
  uploadfailedimage: "Unggahan gagal: Resolusi gambar maksimum adalah 25x25 piksel!",
  Successfuloperation: "Operasi berhasil",
  operationfailed: "Operasi gagal",
  Editmark: "Edit markup",
  Pleaseselecttheiconyouwanttodelete: "Silakan pilih ikon yang ingin Anda hapus.",
  successfullydeleted: "Penghapusan berhasil",
  failedtodelete: "Penghapusan gagal",
  north: "utara",
  South: "Selatan",
  West: "Barat",
  East: "Timur",
  truenorth: "Utara",
  duesouth: "ke selatan",
  duewest: "ke arah barat",
  Zhengdong: "tepat di timur",
  partial: "bias",
  historyrecord: "Catatan sejarah",
  group: "Kelompok",
  pleaseselectagroup: "Silakan pilih grup",
  sender: "Pengirim",
  Pleaseselectuser: "Silakan pilih pengguna",
  Sendtime: "Waktu pengiriman",
  startrange: "Rentang awal",
  endrange: "Rentang akhir",
  startdate: "tanggal mulai",
  Startingtime: "Waktu mulai",
  enddate: "Tanggal Akhir",
  to: "ke",
  Clear: "Jernih",
  Confirm: "Tentu",
  state: "negara",
  Pleaseselectastatus: "Silakan pilih status",
  Processed: "Diproses",
  Processor: "Orang yang bertanggung jawab",
  processtime: "Waktu pengerjaan",
  serialnumber: "Nomor seri",
  operate: "beroperasi",
  ViewSOSlocation: "Periksa lokasi SOS",
  Back: "kembali",
  Warmreminder: "Sebagai pengingat: Data referensi bersumber dari pihak ketiga mungkin mengandung kesalahan ",
  SOSalarmsintemporarygroupsarenotrecorded: "Peringatan SOS dalam grup sementara tidak direkam.",
  Pleaseselectatype: "Silakan pilih jenisnya",
  deleted: "Dihapus",
  next: "Berikutnya",
  Tobeprocessed: "Sedang diproses",
  dealwith: "menghadapi",
  alreadydispatched: "Petugas pengiriman",
  temporarygroup: "Kelompok sementara",
  NortheasternHemisphere: "Belahan Bumi Timur Laut",
  northwesternhemisphere: "Belahan Bumi Barat Laut",
  SoutheasternHemisphere: "Belahan Bumi Tenggara",
  southwesternhemisphere: "Belahan Bumi Barat Daya",
  Nolocationtrack: "Tidak ada pelacakan lokasi",
  Latitudeandlongitude: "garis lintang dan garis bujur",
  Reportingtime: "Waktu pelaporan",
  Positioningtime: "Waktu penentuan posisi",
  Alarminformation: "Informasi alarm",
  AlarminformationTips: "Untuk pesan peringatan lainnya, silakan periksa riwayat.",
  initiatesos: "Mulai SOS",
  Forcedvideo: "Video paksa",
  videocall: "Panggilan video",
  Videopostback: "Video kembali",
  leave: "meninggalkan",
  Enter: "Masuk",
  fence: "pagar",
  newgroup: "Buat grup baru",
  Joingroup: "Bergabunglah dengan grup",
  Thegroupnamealreadyexistspleasereenterit: "Nama grup sudah ada, silakan masukkan lagi.",
  Groupcreatedsuccessfully: "Grup berhasil dibuat",
  Groupcreationfailedpleasecreateagain: "Pembuatan grup gagal, silakan coba lagi!",
  Pleaseenterthegrouppassword: "Silakan masukkan kata sandi grup.",
  Thegrouppasswordyouenterediswrong: "Kata sandi grup yang Anda masukkan salah.",
  Grouppassword: "Kata sandi grup",
  Dissolve: "Bubar",
  Exit: "berhenti",
  Disbandselforganizedgroup: "Membubarkan grup yang dibentuk sendiri",
  Exittheselfcreatedgroup: "Keluar dari grup yang dibuat sendiri",
  ExiDissolvetheselfestablishedgroupt: "Apakah kamu yakin ingin membubarkan grup yang kamu buat sendiri?",
  Exitselfbuiltgroup: "Apakah Anda yakin ingin meninggalkan grup yang Anda buat sendiri ini?",
  Grouptransfer: "Pengalihan kepemilikan grup",
  Theusersselfbuiltgroupfunctionisnotopened: "Fungsi grup yang dibuat pengguna tidak diaktifkan.",
  Createfence: "Buat pagar",
  Editfence: "Edit Pagar",
  electricfence: "pagar elektronik",
  Electronicfencelist: "Daftar pagar elektronik",
  fencename: "Nama Pagar",
  efficient: "efisien",
  Invalid: "Kegagalan",
  Forbidden: "Tidak ada jalan keluar",
  Noentry: "Dilarang masuk",
  Pleasesearchorselfselectthefencedareafirst: "Silakan pilih area yang berpagar terlebih dahulu!",
  Areyousureyouwanttodeletetheelectronicfence: "Apakah Anda yakin ingin menghapus geofence?",
  Triggermode: "Metode pemicu",
  timesetting: "Pengaturan waktu",
  Pleaseenterthefencename: "Silakan masukkan nama pagar.",
  tipsItconsists: "Kode ini terdiri dari 1-15 angka, huruf, dan garis bawah dalam bahasa Mandarin, dan tidak boleh diawali dengan garis bawah.",
  tipsItconsistsName:
    "Nama pagar terdiri dari 1-15 karakter Tionghoa, angka, huruf, dan garis bawah, dan tidak boleh diawali dengan garis bawah.",
  Pleaseselectamethodofentryandexit: "Silakan pilih metode masuk/keluar Anda!",
  Pleaseselectatleastoneday: "Silakan pilih setidaknya satu hari.",
  Notinfenceusers: "Pengguna yang tidak berada di dalam pagar",
  Usersonthefence: "pengguna di dalam pagar",
  Validdate: "Tanggal Berlaku",
  Validperiod: "Periode berlaku",
  Selecttimerange: "Pilih rentang waktu",
  Monday: "pada hari Senin",
  Tuesday: "Selasa",
  Wednesday: "Rabu",
  Thursday: "Kamis",
  Friday: "Jumat",
  Saturday: "Sabtu",
  Sunday: "Minggu",
  Createdsuccessfully: "Pembuatan berhasil",
  Thefencenameisduplicated: "Harap ubah nama pagar jika ada yang sama dan coba lagi.",
  Ifnotselected: "Jika tidak dipilih, pengaturan default adalah permanen.",
  FenceEdit: "Pengeditan pagar",
  Removalfailedfence: "Penghapusan gagal karena daftar pengguna yang dibatasi kosong!",
  Failedtoaddfence: "Penambahan gagal karena daftar pengguna yang dibatasi kosong!",
  Outofboundsrecord: "Melanggar rekor batas",
  Outofboundstype: "Jenis di luar batas",
  Pleaseselectausername: "Silakan pilih nama pengguna",
  Pleaseselecttriggermethod: "Silakan pilih metode pemicu.",
  Crossborderdate: "Tanggal melintasi batas",
  currentrecord: "Catatan saat ini",
  Triggertime: "Waktu pemicu",
  Pleaseselectafencename: "Silakan pilih nama pagar",
  Releasetime: "Waktu rilis",
  Batchdownload: "Unduhan massal",
  Recordingplayback: "Pemutaran rekaman",
  download: "unduh",
  Areyousureyouwant: "Apakah Anda yakin ingin mengunduh rekaman yang dipilih?",
  Record: "Catatan",
  Pleaseselecttherecording: "Silakan pilih rekaman audio yang ingin Anda unduh.",
  downloadsuccessful: "Pengunduhan berhasil",
  Voiceaudio: "Audio suara",
  text: "teks",
  voice: "suara",
  Doubleclicktocreate: "Klik dua kali untuk membuat",
  Doubleclicktosave: "Klik dua kali untuk menyimpan",
  outofboundsperson: "Melintasi batas",
  temporarygroupTow: "Kelompok sementara",
  Theotherpartyhasnoanswer: "Tidak ada respons dari pihak lain!",
  sosrecord: "Sejarah SOS",
  UnhandledSOSexists: "Terdapat sinyal SOS yang belum diproses.",

  RealTimeVideo: "Video waktu nyata",
  ForceVideo: "Pengunggahan video paksa/pengembalian video",
  VideoCall: "Panggilan video",
  CurrentlyNoRealTimeVideo: "Saat ini tidak ada siaran video langsung.",
  VideoUserList: "Daftar Pengguna Video",
  Filter: "menyaring:",
  All: "semua",
  Online: "On line",
  Offline: "Offline",
  GroupUser: "Grup/Pengguna",
  ForceVideos: "Video paksa",
  PleaseSelectTheUserWhoNeedsxxx: "Silakan pilih pengguna!",
  TheDispatcherCannotForceIt: "Petugas operator tidak boleh menarik secara paksa!",
  VoiceCallInProgress: "Dalam panggilan suara!",
  PleaseActivateTheVideoServiceAndVideoCallFunctionOnTheManagementPlatformFirst:
    "Harap aktifkan layanan video dan fungsi panggilan video pada platform manajemen terlebih dahulu!",
  PleaseEnableTheVideoCallFunctionOnTheManagementPlatformFirst:
    "Harap aktifkan fungsi panggilan video di platform manajemen terlebih dahulu!",
  UserIsNotOnline: "Pengguna sedang offline",
  OnlySupportsInitiatingVideoCallsToASingleUser: "Hanya mendukung memulai panggilan video ke satu pengguna.",
  ThisUserHasNotActivatedTheVideoServiceOnTheManagementPlatform:
    "Pengguna ini belum mengaktifkan layanan video di platform manajemen!",
  ThisUserHasNotEnabledTheVideoCallFunctionOnTheManagementPlatform:
    "Pengguna ini belum mengaktifkan fungsi panggilan video pada platform manajemen!",
  VideoCallInProgress: "Panggilan video sedang berlangsung!",
  CannotCallTheTerminalThatIsTransmittingVideo: "Tidak dapat menghubungi terminal yang sedang mengirimkan video.",
  TheOtherPartyIsBusy1: "Pihak lain sedang sibuk",
  ThisUserHasNotEnabledTheForceVideoFunctionOnTheManagementPlatform:
    "Pengguna ini belum mengaktifkan fungsi pemutaran video paksa pada platform manajemen!",
  CannotForceTheTerminalThatIsTransmittingVideo: "Anda tidak dapat memaksa terminal yang saat ini sedang mengirimkan video kembali.",
  UserAlreadyExists: "Pengguna tersebut sudah ada.",

  TheOtherPartyInvitedMeToAVideoCall: "Pihak lain mengundang untuk melakukan panggilan video...",
  Connecting: "Menghubungkan...",
  TheOtherPartyHasRejected: "Pihak lainnya telah menolak.",
  TheOtherPartyHasHungUp: "Pihak lain telah menutup telepon",
  TheOtherPartyDidNotAnswer: "Pihak lainnya tidak menjawab.",
  TheOtherPartyIsBusy2: "Pihak lain sedang sibuk!",
  ConnectionInterruptedCallEnded: "Koneksi terputus, panggilan berakhir!",
  AnswerFailed: "Panggilan gagal",
  ConnectionFailed: "Koneksi gagal",
  exceedFenceMsg: "Jumlah maksimum pagar yang dapat dibuat telah terlampaui. Harap hapus pagar tersebut dan coba lagi.",

  userPatrol: {
    searchLable: {
        PlanName: "Nama Proyek",
        PatrolUsers: "Pengguna patroli",
        ExecutionResult: "Hasil eksekusi",
        PatrolTime: "Waktu Patroli",
        PatrolPointName: "Nama-nama Titik Patroli",
    },
    placeholder: {
        PleaseEnterThePlanMame: "Silakan masukkan nama paket.",
        PleaseEnterThePatrolUser: "Silakan masukkan nama pengguna patroli.",
        PleaseSelectTheExecutionResult: "Silakan pilih hasil eksekusi.",
    },
    tableHeader:{
        PlanName: "Nama Proyek",
        patrolPoint: "titik patroli",
        PatrolUsers: "Pengguna patroli",
        PatrolPointName:"Nama-nama Titik Patroli",
        StartTime: "Waktu mulai",
        EndTime: "Waktu berakhir",
        ExecutionResult: "Hasil eksekusi",
        type:"jenis",
        PatrolTime:"Waktu Patroli",
    },
    status: {
        NotStarted:"Belum dimulai",
        InProgress: "sedang berlangsung",
        Completed: "Selesai",
        MissingPatrol: "Inspeksi terlewatkan",
        positioning: "posisi",
        NFC:"NFC",
        Bluetooth: "Bluetooth",
    },
    StartingRange: "Rentang awal",
    EndRange: "Rentang akhir",
    ViewDetails:"periksa detailnya",
    PatrolTrajectory: "Rute patroli",
    patrol:'Patroli',
    PatrolFailed:"Patroli gagal",
    PatrolLog: "Catatan Patroli",
  },
};
